__turbopack_context__.v({
  "alignCenter": "ReviewRating-module__15-8NW__alignCenter",
  "alignLeft": "ReviewRating-module__15-8NW__alignLeft",
  "alignRight": "ReviewRating-module__15-8NW__alignRight",
  "iconsAndCount": "ReviewRating-module__15-8NW__iconsAndCount",
  "iconsAndCountSingleStar": "ReviewRating-module__15-8NW__iconsAndCountSingleStar",
  "iconsAndCountXS": "ReviewRating-module__15-8NW__iconsAndCountXS",
  "iconsAndCountXXS": "ReviewRating-module__15-8NW__iconsAndCountXXS",
  "inverse": "ReviewRating-module__15-8NW__inverse",
  "large": "ReviewRating-module__15-8NW__large",
  "reviewRating": "ReviewRating-module__15-8NW__reviewRating",
  "singleStarIconAndRating": "ReviewRating-module__15-8NW__singleStarIconAndRating",
});
